export default __webpack_public_path__ + "static/media/albert.d781e0fd.svg";